import { useState } from "react";
import api from "../../../utils/api";
import { bugsnagClient } from "../../../bugsnag/bugsnag";
import type { NotifiableError } from "@bugsnag/js";
import { CablePaths } from "./types";

export const useCablePaths = (floorPlanId: number | null) => {
  const [cablePaths, setCablePaths] = useState<CablePaths | null>(null);
  const [showCablePaths, setShowCablePaths] = useState(false);
  const [loadingPaths, setLoadingPaths] = useState(false);

  const toggleCablePaths = async () => {
    if (cablePaths) {
      setShowCablePaths(!showCablePaths);
      return;
    }

    if (!floorPlanId) {
      console.error("No floor plan ID available");
      return;
    }

    setLoadingPaths(true);
    try {
      const pathsData = await api.getFloorPlanGraph(floorPlanId);
      setCablePaths(pathsData);
      setShowCablePaths(true);
    } catch (error) {
      console.error("Error loading cable paths:", error);
      bugsnagClient.notify(error as NotifiableError);
    } finally {
      setLoadingPaths(false);
    }
  };

  return {
    cablePaths,
    showCablePaths,
    loadingPaths,
    toggleCablePaths,
  };
};
